import type { AnalyticsOptions, CoreAnalyticsOptions } from "owa-analytics-types";
import type { StartupAnalyticsInfo } from "owa-config-types";
import { initializeAnalytics as initializeAnalyticsCore, setIsAnalyticsWorkerActive, } from "owa-analytics-core";

export async function initializeOnMainThread(analyticsOptions: AnalyticsOptions, useWebWorkerAsDefault: boolean, startupAnalyticsInfo: StartupAnalyticsInfo): Promise<CoreAnalyticsOptions> {
    // When an event fails in the Web Worker, we will try to send it using the main thread but
    // still want to use the Web Worker for the others events. If the Web Worker fails to launch
    // or fails repeatedly, the default will become the main thread instead of the Web Worker.
    analyticsOptions.useAnalyticsWorker = useWebWorkerAsDefault;
    setIsAnalyticsWorkerActive(useWebWorkerAsDefault);
    
    return initializeAnalyticsCore(analyticsOptions, startupAnalyticsInfo);
}
